export const CASE_ACTION_SUBMIT = 'CASE_ACTION_SUBMIT';
export const CASE_ACTION_SUBMIT_SUCCESS = 'CASE_ACTION_SUBMIT_SUCCESS';
export const CASE_ACTION_SUBMIT_FAIL = 'CASE_ACTION_SUBMIT_FAIL';
export const CASE_ACTION_INFO_MODAL_CLOSE = 'CASE_ACTION_INFO_MODAL_CLOSE';
export const CASE_ACTION_CONFIRM_MODAL_OPEN = 'CASE_ACTION_CONFIRM_MODAL_OPEN';
export const CASE_ACTION_CONFIRM_MODAL_CLOSE =
  'CASE_ACTION_CONFIRM_MODAL_CLOSE';
export const CASE_ACTION_INFO_MODAL_CLOSE_WITHOUT_RENDER =
  'CASE_ACTION_INFO_MODAL_CLOSE_WITHOUT_RENDER';

export const caseActionSubmit = ({ caseActionDetails }) => ({
  type: CASE_ACTION_SUBMIT,
  payload: { caseActionDetails }
});

export const caseActionSubmitSuccess = () => ({
  type: CASE_ACTION_SUBMIT_SUCCESS
});

export const caseActionSubmitFail = () => ({
  type: CASE_ACTION_SUBMIT_FAIL
});

export const caseActionInfoModalClose = () => ({
  type: CASE_ACTION_INFO_MODAL_CLOSE
});

export const caseActionConfirmModalOpen = () => ({
  type: CASE_ACTION_CONFIRM_MODAL_OPEN
});

export const caseActionConfirmModalClose = () => ({
  type: CASE_ACTION_CONFIRM_MODAL_CLOSE
});

export const caseActionInfoModalCloseWithoutRender = () => ({
  type: CASE_ACTION_INFO_MODAL_CLOSE_WITHOUT_RENDER
});
